import api from './axiosConfig';

export interface ValidationResponse {
    valid: boolean;
}

export interface AccountMeterValidationResponse {
    account_number_valid: boolean;
    electricity_meter_valid: boolean;
}

export const indigentValidationService = {
    validatePersonalId: async (saId: string, financialYear: string, indigentNumber?: string): Promise<ValidationResponse> => {
        try {
            let url = `/indigent-search/validate/sa-id?sa_id=${saId}&financial_year=${financialYear}`;
            if (indigentNumber) {
                url += `&indigent_number=${indigentNumber}`;
            }
            const response = await api.get<ValidationResponse>(url);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    
    validateAccountMeter: async (accountNumber: string, electricityMeterNo: string, financialYear: string, indigentNumber?: string): Promise<AccountMeterValidationResponse> => {
        try {
            let url = `/indigent-search/validate/account-meter?account_number=${accountNumber}&electricity_meter_no=${electricityMeterNo}&financial_year=${financialYear}`;
            if (indigentNumber) {
                url += `&indigent_number=${indigentNumber}`;
            }
            const response = await api.get<AccountMeterValidationResponse>(url);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
}; 